const settings = [
  {
    id: 'cadb0ac0-4a63-4f26-9c04-29c28d7b6a65',
    factoryCode: 'XC',
    managingOffice: 'CN00N1',
    managingOfficeName: 'NLO/CHINA OFFICE',
    managingUserID: 'TSai',
    managingUser: 'Toramtarun Sai',
    managingUserEmail: 'Toramtarun.Sai@nike.com',
    isActive: true,
    divisionCode: '20'
  },
  {
    id: '8cca64fa-11e8-45b6-a980-9ed7254ee4eb',
    factoryCode: 'XE',
    managingOffice: 'CN00N1',
    managingOfficeName: 'NLO/CHINA OFFICE',
    managingUserID: 'TSai',
    managingUser: 'Toramtarun Sai',
    managingUserEmail: 'Toramtarun.Sai@nike.com',
    modifiedBy: 'dpom.it01@nike.com',
    modifiedDate: '2023-02-07T05:52:32.432Z',
    isActive: true,
    divisionCode: '10'
  },
  {
    id: 'f2eb09bc-7a48-4148-b05b-6f06943b6e34',
    factoryCode: 'XE',
    factoryName: 'JIA INTERNATIONAL CO., LTD.',
    managingOffice: 'CN00N1',
    managingOfficeName: 'NLO/CHINA OFFICE',
    managingUserID: 'Unknown',
    managingUser: 'Unknown',
    managingUserEmail: 'Stephanie.Wang@nike.com',
    isActive: true,
    divisionCode: '30'
  },
  {
    id: '30b2b7e3-fd28-4995-b16b-ce1cd5429d5a',
    factoryCode: 'XG',
    factoryName: 'EVA OVERSEAS INTERNATIONAL LIMITED',
    managingOffice: 'CN00N1',
    managingOfficeName: 'NLO/CHINA OFFICE',
    managingUserID: 'Unknown',
    managingUser: 'Unknown',
    managingUserEmail: 'Stephanie.Wang@nike.com',
    isActive: true,
    divisionCode: '10'
  },
  {
    id: '1c1081e8-076d-4fd9-b99f-dd0672cdbe0b',
    factoryCode: 'XG',
    factoryName: 'EVA OVERSEAS INTERNATIONAL LIMITED',
    managingOffice: 'CN00N1',
    managingOfficeName: 'NLO/CHINA OFFICE',
    managingUserID: 'Unknown',
    managingUser: 'Unknown',
    managingUserEmail: 'Wenna.Wu@nike.com',
    isActive: true,
    divisionCode: '20'
  }
];

export const conversationCodeLookup = [{
  conversationCode: '101',
  conversationCodeDescription: 'N-Buy Not Ready',
  modifiedBy: 'Bhupender Sain',
  modifiedDate: '2021-10-04'
}, {
  conversationCode: '101',
  conversationCodeDescription: 'N-Buy Not Ready',
  modifiedBy: 'Bhupender Sain',
  modifiedDate: '2021-10-04'
}, {
  conversationCode: '101',
  conversationCodeDescription: 'N-Buy Not Ready',
  modifiedBy: 'Bhupender Sain',
  modifiedDate: '2021-10-04'
}];

export const convoCodeMock = [
  {
    ConversationCode: '1',
    ConversationDescription: 'Doc Reject - Testing Addition',
    modifiedBy: 'dpom.pmo04@nike.com',
    modifiedDate: '2025-06-04T07:03:43.560Z',
    isActive: true,
    id: '00c9df12-ce26-4ed1-8bda-5415cbc4afc7',
    conversationCategory: 'REJECT',
    divisionCode: '10'
  },
  {
    ConversationCode: '2',
    ConversationDescription: 'Doc Reject - test',
    modifiedBy: 'dpom.pmo04@nike.com',
    modifiedDate: '2024-11-29T09:12:11.538Z',
    isActive: true,
    id: '13519083-ee70-4bae-84a1-c2c336558403',
    conversationCategory: 'REJECT',
    divisionCode: '20'
  },
  {
    ConversationCode: '3',
    ConversationDescription: 'Po Reject2 - test',
    modifiedBy: 'dpom.pmo04@nike.com',
    modifiedDate: '2025-04-24T15:33:41.182Z',
    isActive: true,
    id: '4503bbee-9efd-4d7b-adc3-775a24424e5a',
    conversationCategory: 'REJECT',
    divisionCode: '30'
  },
  {
    ConversationCode: '4',
    ConversationDescription: 'Doc Reject - test1',
    modifiedBy: 'dpom.pmo04@nike.com',
    modifiedDate: '2024-11-29T09:13:29.899Z',
    isActive: true,
    id: 'dc400c15-07da-4c0f-8673-0871b9400b22',
    conversationCategory: 'REJECT',
    divisionCode: '10'
  }
];
export const gacReasonCodeLookup = [{
  goodsAtConsolidatorReasonCode: '10',
  goodsAtConsolidatorReasonDescription: 'N-Buy Not Ready',
  modifiedBy: 'Bhupender Sain',
  modifiedDate: '2021-10-04'
}, {
  goodsAtConsolidatorReasonCode: '10',
  goodsAtConsolidatorReasonDescription: 'N-Buy Not Ready',
  modifiedBy: 'Bhupender Sain',
  modifiedDate: '2021-10-04'
}, {
  goodsAtConsolidatorReasonCode: '10',
  goodsAtConsolidatorReasonDescription: 'N-Buy Not Ready',
  modifiedBy: 'Bhupender Sain',
  modifiedDate: '2021-10-04'
}];

export default settings;
